import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import SectionContent from "./../scripts/sectionContent";

const About = () => {

    const data = useStaticQuery(graphql`
        query aboutSectionQuery {
            allContentfulSectionContent(filter: {section: {eq: "About"}, page: {eq: "Homepage"}}) {
                edges {
                    node {
                        id
                        content {
                            childMarkdownRemark {
                                html
                                rawMarkdownBody
                            }
                        }
                        contentType
                    }
                }
            }
            contentfulSectionImages(page: {eq: "Homepage"}, section: {eq: "About"}) {
                image {
                    fluid(quality:100) {
                        src
                    }
                }
            }
        }
    `);

    const sectionContent = new SectionContent(data.allContentfulSectionContent);

    return (
        <section id="about" className="about section container mx-auto">
            <div className="flex">
                <div className="w-full md:w-10/12 mx-auto">
                    <div className="relative">
                        <img className="about__image mx-auto md:mx-0" src={ data.contentfulSectionImages.image.fluid.src } alt="About" />
                        <div className="about__content bg-white shadow-lg rounded-sm border border-gray-100">
                            <h3 className="section__heading text-xl mt-8 md:mt-0 mb-4 md:ml-16 md:w-1/2">{ sectionContent.getContent('heading').rawMarkdownBody }</h3>
                            <div dangerouslySetInnerHTML={{ __html: sectionContent.getContent('description').html }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;